import { Component, computed, input } from '@angular/core';
import {
  RentalAgreementStatus,
  RentalAgreementStatusesDisplayNames
} from '@app/features/operations/rental-agreements/rental-agreements.model';

@Component({
  selector: 'app-ra-status-badge',
  standalone: true,
  imports: [],
  templateUrl: './ra-status-badge.component.html',
  styleUrl: './ra-status-badge.component.scss'
})
export class RaStatusBadgeComponent {
  status = input.required<RentalAgreementStatus>();
  displayName = computed(() => RentalAgreementStatusesDisplayNames[this.status()]);
}
